import {
  DashboardAdminPermissions,
  DashboardUserPermissions,
  ProgramUserPermissions,
  ProgramAdminPermissions,
} from './common';

const USAAAdminFeaturePermissions = {
  MayViewAdminPage: 'V-MVAP',
};

const USAAClientUserPermissions = {
  ...DashboardUserPermissions,
  ...ProgramUserPermissions,
};

const USAAClientAdminPermissions = {
  ...USAAClientUserPermissions,
  ...DashboardAdminPermissions,
  ...ProgramAdminPermissions,
};

const USAAAdminPermissions = {
  ...USAAClientAdminPermissions,
  ...USAAAdminFeaturePermissions,
};

export const USAARoles = {
  Admin: {
    name: 'USAA-Admin',
    permissions: USAAAdminPermissions,
  },
  ClientAdmin: {
    name: 'USAA-Client-Admin',
    permissions: USAAClientAdminPermissions,
  },
  ClientUser: {
    name: 'USAA-Client-User',
    permissions: USAAClientUserPermissions,
  },
} as const;
